// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function UnapprovedBadContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                (rowContractData.comboStatus === 'u'  && rowContractData.inputMissingRollup > 0 && rowContractData.contractLevel !== 'Component Type')
                &&
                <div>
                    <Tooltip
                        enterDelay={1000}
                        title="UnapprovedBadContractAvatar"
                    >
                    <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}>u
                    </Avatar>
                    </Tooltip>
                </div>}
            {
                (rowContractData.comboStatus === 'u'  && rowContractData.inputMissingRollup > 0  && rowContractData.contractLevel === 'Component Type')
                &&
                <div>
                    <Tooltip
                        enterDelay={1000}
                        title="UnapprovedBadContractAvatar"
                    >
                        <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}> </Avatar>
                    </Tooltip>
                </div>}
        </Box>

    )

}
